<template>
  <header class="flex flex-wrap justify-between items-center pl-2 bg-brand border-b border-section_border">
    <div class="flex-grow text-white sub-title absolute top-0.5">
      電車もバスもシェアサイクルも！ラクラク検索
    </div>
    <div class="text-white text-2xl pt-2 font-bold button-wide" @click="top">
      にいがたチョイnavi
    </div>
    <div class="float-right bg-black h-full text-white px-4 py-3" @click="linkJR">
      <img src="@/assets/images/logo_jr.svg" alt="ロゴ" class="w-8" />
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from "../../constants";

export default {
  name: 'TheHeader',
  computed: {
    ...mapGetters({
      from: 'map/getFrom'
    })
  },
  methods: {
    mae_maas_url: function () {
      return Constants.LINK_BASE_URL + '/'
    },
    top: function () {
      this.$router.push({ name: 'root', params: { lang: this.lang } })
    },
    linkJR: function () {
      window.open('https://www.jreast.co.jp/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-title {
  font-size: 0.5rem;
}

.button-wide{
  width: calc(100% - 64px);;
}
</style>
